import { AnimalSummary } from '../animals/animal';
import { ControllerSummary } from '../controllers/controller';
import { MilkControl } from '../milk-control/milk-control';
import { ProducerSummary } from '../producers/producer';
import { Id, Json, JsonEntity } from '@homeleite/arch';
import { EMPTY } from '@homeleite/common-utils';


export class LogOperation implements JsonEntity {
    public entityType: string = EMPTY;

    toJson() {
        return Json.to.simple(this);
    }

    static fromJson(json: any): LogOperation {
        if (!json) return null as any;
        return Json.from.simple(json, LogOperation);
    }
}

export class ApplicationLog implements JsonEntity {
    public id: string = Id.gen();
    public tenantId: string = EMPTY;
    public result: LogResult;
    public producer: ProducerSummary = new ProducerSummary();
    public controller: ControllerSummary = new ControllerSummary();
    public animal: AnimalSummary = new AnimalSummary();
    public operation: LogOperation = new LogOperation();
    public milkControl: MilkControl = new MilkControl();

    toJson() {
        return Json.to.simple(this);
    }

    static fromJson(json: any): ApplicationLog {
        if (!json) return null as any;

        return Json.from.simple(json, ApplicationLog, {
            producer: ProducerSummary.fromJson(json?.producer),
            controller: ControllerSummary.fromJson(json?.controller),
            animal: AnimalSummary.fromJson(json?.animal),
            operation: LogOperation.fromJson(json?.operation),
            milkControl: MilkControl.fromJson(json?.milkControl)
        });
    }
}

export interface SuccessLogResult {
    '@type': 'SuccessLogResult';
    end: string;
}

export interface FailLogResult {
    '@type': 'FailLogResult';
    end: string;
    data: FailData;
}

export interface FailData {
    '@type': string;
    message?: string;
    description?: string;
    code?: number;
}

export type LogResult = SuccessLogResult | FailLogResult;
